module.exports = __webpack_public_path__ + "img/comment.2840ad61.svg";